import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigApi } from './config-api.model';

@Injectable()
export class Globals implements OnInit {

    private configUrl = '../../assets/config.json';
    role: string;

    ngOnInit(): void {
        this.loadConfig();
    }

    constructor(private httpClient: HttpClient) {
    }

    private loadConfig() {
        this.httpClient
            .get<ConfigApi>(this.configUrl)
            .pipe()
            .subscribe(res => {
                this.role = `${res.webApiUrl}/api/Inicial/`;
            });
    }
}


// WEBPACK FOOTER //
// D:/Agents/amapa/_work/8/s/ANGULAR/src/app/shared/globals.models.ts